import moment from "moment-timezone";
import "moment-timezone/node_modules/moment/locale/nb";
import "moment-timezone/node_modules/moment/locale/sv";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import axiosClient from "./API/AxiosClient";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import ScrollToTop from "./components/ScrollToTop";
import store from "./configureStore";
import { system } from "./Constants";
import { getBasename } from "./Helper";
import { initSentry } from "./Sentry";
import ErrorInterceptor from "./store/errorInterceptor";

// Set moment default locale
moment.locale(system.LANGUAGE);

const isStandalone = document.documentElement.classList.contains("standalone");

if (isStandalone) {
    const bodyElement = document.querySelector("body");
    if (bodyElement) {
        bodyElement.style.margin = "0";
    }
}

export const renderInScope = (element: React.ReactElement) => {
    return (
        <div className="r360-scope">
            <div className="r360-content">{element}</div>
        </div>
    );
};

ErrorInterceptor.interceptor(axiosClient, store);

// Initialize Sentry error logging.
initSentry();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const container = document.getElementById("main-content-node")!;
const root = createRoot(container);
const basename = getBasename();

root.render(
    <ErrorBoundary outsideScope>
        <Provider store={store}>
            <BrowserRouter basename={basename}>
                <ScrollToTop />
                {renderInScope(<App />)}
            </BrowserRouter>
        </Provider>
    </ErrorBoundary>
);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
